module.exports = __webpack_public_path__ + "static/02-f00dbd4ae942ae1319e2720593e66b41.png";